<template>
  <time-line class="mt-5">
    <time-line-item
      v-for="(item, index) in results"
      :key="index"
      icon="fas fa-user-tie"
    >
      <template #date>
        <div class="history-date-title">
          {{
            $formatDate(
              item.createdDate,
              $templateDate.default
            )
          }}
        </div>
        <label class="history-date-value font-12 font-weight-bold">
          {{ $formatDate(item.createdDate, $templateDate.hour) }}
        </label>
      </template>
      <div id="main-info" class="row">
        <div class="col-3 item-col pl-5">
          <div class="track-status-name">
            <label class="info-field-value">
              {{ item.activityTypeName | empty }}
            </label>
          </div>
          <div class="info-field-title font-14 color-gray-6 mt-3">Estatus:</div>
          <label class="info-field-value">
            <label class="circle-dot" :class="item.activeFlag ? 'active-dot': 'inactive-dot'"></label>
            <label class="ml-3">{{ isActiveUser(item.activeFlag) }}</label>
          </label>
        </div>
        <div class="divider-left mr-4" />
        <div class="col-8">
          <div class="col-12 row">
            <div class="col-4 item-col">
              <div class="info-field-title font-14 color-gray-6">Administrado por:</div>
              <label class="info-field-value">
                {{ item.createdByName | empty }}
              </label>
            </div>
            <div class="col-4 item-col">
              <div class="info-field-title font-14 color-gray-6">Nombre del Usuario:</div>
              <label class="info-field-value">
                {{ item.createdByUsername | empty }}
              </label>
            </div>
          </div>
          <div class="col-12 item-col mt-3">
            <div class="info-field-title font-14 color-gray-6">Descripción:</div>
            <label class="info-field-value">
              {{ item.description | empty }}
            </label>
          </div>
        </div>
      </div>
    </time-line-item>
    <div class="pt-3">
      <custom-result-not-found v-if="results.length === 0" />
    </div>
  </time-line>
</template>
<script>
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import CustomResultNotFound from 'custom-result-not-found';
import {
  getUserActivity as _getUserActivity,
} from '@/modules/users/api';

export default {
  name: 'UserActivityHistory',
  components: {
    TimeLine,
    TimeLineItem,
    CustomResultNotFound,
  },
  props: {
    userId: {
      type: String,
      default: () => null,
    },
  },
  data() {
    return {
      results: [],
    };
  },
  computed: {
    isActiveUser() {
      return (isActive) => isActive ? 'Activo' : 'Inactivo';
    },
  },
  async mounted() {
    await this.loadUserActivity();
  },
  methods: {
    async loadUserActivity() {
      const { data: activityHistory } = await _getUserActivity(this.userId);
      this.results = activityHistory;
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/sass/config/_colors.scss';

.info-field-title, .history-date-value {
  font-weight: normal !important;
}
.divider-left {
  border-left: 1px solid #b5c3bc;
  opacity: 0.4;
}
.circle-dot {
  border-radius: 100%;
  height: 12px;
  width: 12px;
  margin: 0;
}
.active-dot {
  background-color: map-get($colors, 'primary-15');
}
.inactive-dot {
  background-color: map-get($colors, 'gray-2');
}
</style>
